import React, { useEffect } from "react";
import history from "../../history";
import { Row, Col } from "reactstrap";
import DesignCard from "../DesignCard";
import { fetchQueryParams } from "../../utils/comman";
import CustomButton from "../CustomButton";

import get from "lodash/get";

const _ = { get };

function Informatin(props) {
  let { elements } = props;

  useEffect(() => {
    let queryParams = props.query;
    if (props.selectedId) {
      props.handleSingleDealerFetch(props.selectedId);
    }
  }, [props.selectedId]);

  const handleGoBack = () => {
    props.handleToggleModel();
  };
  return (
    <React.Fragment>
      {props.dealerData !== null ? (
        <React.Fragment>
          <Row>
            <Col md="12">
              <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                <span>
                  {_.get(
                    elements,
                    "dealerDetailElements.subHeadingPersonalInformationElement",
                    "PERSONAL INFORMATION"
                  )}
                </span>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.clubCoordinatorNameLabel",
                  "Club Coordinator Name"
                )}
                titleName={props.dealerData.storeManagerName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.emailLabel",
                  "Email"
                )}
                titleName={props.dealerData.emailId}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.phoneNumberLabel",
                  "Phone Number"
                )}
                titleName={props.dealerData.phone}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.alternatePhoneNumberLabel",
                  "Alternate Phone Number"
                )}
                titleName={props.dealerData.altPhone}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.countryLabel",
                  "Country"
                )}
                titleName={props.dealerData.country}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.stateLabel",
                  "State"
                )}
                titleName={props.dealerData.state}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(elements, "dealerDetailElements.cityLabel", "City")}
                titleName={props.dealerData.city}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.landmarkLabel",
                  "Landmark"
                )}
                titleName={props.dealerData.landmark}
              />
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.pinCodeLabel",
                  "Pincode"
                )}
                titleName={props.dealerData.pincode}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                cardClass={"textarea"}
                name={_.get(
                  elements,
                  "dealerDetailElements.addressLineOneLabel",
                  "Address Line 1"
                )}
                titleName={props.dealerData.addressLine1}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                cardClass={"textarea"}
                name={_.get(
                  elements,
                  "dealerDetailElements.addressLineTwoLabel",
                  "Address Line 2"
                )}
                titleName={props.dealerData.addressLine2}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                cardClass={"textarea"}
                name={_.get(
                  elements,
                  "dealerDetailElements.addressLineThreeLabel",
                  "Address Line 3"
                )}
                titleName={props.dealerData.addressLine3}
              />
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.latitudeLabel",
                  "Latitude"
                )}
                titleName={props.dealerData.latitude}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.longitudeLabel",
                  "Longitude"
                )}
                titleName={props.dealerData.longitude}
              />
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <h2 className="title-bar secondary-title f-weight-bold themeColor my-3 pb-2">
                <span>
                  {_.get(
                    elements,
                    "dealerDetailElements.subHeadingMainInformationElement",
                    "MAIN INFORMATION"
                  )}
                </span>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.dealerNameLabel",
                  "Dealer Name"
                )}
                titleName={props.dealerData.dealerName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.dealerPrincipalNameLabel",
                  "Dealer Principal Name"
                )}
                titleName={props.dealerData.dealerPrincipalName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.branchNameLabel",
                  "Branch Name"
                )}
                titleName={props.dealerData.branchName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.dealerStatusLabel",
                  "Dealer Status"
                )}
                titleName={props.dealerData.dealerStatus}
              />
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.dealerIdLabel",
                  "Dealer Id"
                )}
                titleName={props.dealerData.dealerId}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.branchCodeLabel",
                  "Branch Code"
                )}
                titleName={props.dealerData.branchCode}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.dealerWebUrlLabel",
                  "Dealer's Website URL"
                )}
                titleName={props.dealerData.websiteUrl}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.weeklyOffLabel",
                  "Weekly Off"
                )}
                titleName={props.dealerData.weeklyOff}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.branchTypeIdentifierLabel",
                  "Branch Type Identifier"
                )}
                titleName={props.dealerData.branchTypeIdentifier}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.googlePlaceIDLabel",
                  "Google Place ID"
                )}
                titleName={props.dealerData.googlePlaceId}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "dealerDetailElements.businessHourLabel",
                  "Business Hours"
                )}
                titleName={props.dealerData.businessHours}
              />
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <div className="d-flex justify-content-center justify-content-lg-end  position-relative my-3 ">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "dealerDetailElements.backButtonElement",
                    "Back"
                  )}
                  customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  customClick={(e) => handleGoBack(e)}
                />
              </div>
            </Col>
          </Row>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}

export default Informatin;
